import { render, staticRenderFns } from "./18.vue?vue&type=template&id=ca01d8c2&"
import script from "./18.vue?vue&type=script&lang=js&"
export * from "./18.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports